import createCrudVuexModule from "@/store/crud";

export const sector = createCrudVuexModule({
  namespaced: true,
  path: "/sector",
});

export default createCrudVuexModule({
  namespaced: true,
  path: "/management/library/sector",
  moduleName: `managementSector`,
});
